
import SetsMixin from "~/node_modules/sitis-nuxt/lib/mixins/SetsMixin"
import {
  Product
} from "~/node_modules/sitisjs/dist/internal/sections/products/models/Product";
import Breadcrumbs from "~/components/UI/Breadcrumbs.vue";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  name: "Category",

  fetch: async function () {
    this.$store.commit('appState/setLoading', { category: true });
    this.$store.commit('catalog/setCategory', null);
    this.$store.commit('categoryFilters/setLoading', { key: 'get', value: true });
    this.$store.commit('categoryFilters/setFilters', []);
    await this.loadCategoryDetailed();
    await this.loadCategory(false);
    this.$store.commit('appState/setLoading', { category: false });
    this.isNeedRedirect();
  },
  head: function () {
    const description = this.category?.seo?.description || this.category?.metaDescription || "";

    const title = (this.category?.seo?.title || this.category?.name || this.category?.dynamicFields?.catalog_banner_title || "").replace("<br/>", " ");
    const city = this.$store.state?.appState?.config?.city?.data?.prepositional;
    // const fullTitle = [title, 'в', city].filter((t) => !!t).join(" ")
    const fullTitle = title;

    return {
      title: fullTitle,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(fullTitle, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },

  components: {
    Breadcrumbs,
    OurFleetVehiclesTemplateBlock: () => import("~/cms/blocks/OurFleetVehiclesTemplateBlock")
  },

  mixins: [
    SetsMixin
  ],

  computed: {
    breadcrumbs: function () {
      let items = [
        { title: "Главная", path: "/" },
        { title: this.category?.title, path: this.$route.path },
      ];

      return items
    },
    afterCmsPageId: function () {
      const id = this.$store.state.appState?.vars?.['Шаблон посадочной страницы (продукты)'];
      if (!id) {
        return;
      }

      return Number.parseFloat(id)
    },

    faqBlockValue: function () {
      return {
        filterPageId: this.category?.id,
        useApi: true
      }
    },
    articlesBlockValue: function () {
      return {
        tags: this.category?.dynamicFields?.article_tags,
        tagsVisibleCards: this.category?.dynamicFields?.article_tags || [],
        isApi: true
      }
    },
    calculatorBlockValue: function () {
      return {
        title: this.category?.title,
        subtitle: [
          this.category?.dynamicFields?.alt_title,
          this.category?.dynamicFields?.catalog_banner_caption,
          this.category?.dynamicFields?.catalog_banner_caption_2,
          this.category?.dynamicFields?.catalog_banner_caption_3,
        ].filter((t) => !!t).join("<br/>"),
        image: this.category?.imageId,

        dark: true,
        useH1: true
      }
    },
    feedbackFormBlockValue: function () {
      return {
        imageId: this.category?.dynamicFields?.feedback_form_block_image
      }
    },
    freightCalculatorBlockValue: function () {
      return {
        title: `Оставьте заявку на перевозку`,
        cargoName: this.category?.dynamicFields?.freight_calculator_cargo_name || ""
      }
    },
    ourFleetVehiclesTemplateBlockValue: function () {
      const categoryNameGenitiveCase =
          this.category?.dynamicFields?.category_name_genitive_case ||
          this.category?.name ||
          "";

      const filters = (this.filters || []).filter((t) => t.slug !== 'categories');

      return {
        category: this.category,
        products: this.products,
        pagination: {
          ...this.pagination,
          pageCount: this.pageCount
        },

        categoryTitle: "Можем перевезти",

        filters: filters,
        selectedFilters: this.selectedFilters,
        isHideFilter: true,

        onChangePage: this.onChangePage.bind(this),
        onResetFilter: this.clearFilters.bind(this),
        searchProducts: this.searchProducts.bind(this),
        getUpdateFilters: this.getUpdateFilters.bind(this),
        onChangeFilterVariant: this.onChangeFilterVariant.bind(this),
      }
    },
    directionsCompletedProjectsBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },

    extensionsCategory: function () {
      return ['parent']
    },
    defaultPerPage: function () {
      return 999
      return 21
    },
  },

  methods: {
    isNeedRedirect: function() {
      const path = this.$route.path;
      const setsUrl = this.$store.state?.sets?.set?.url
      if (path === setsUrl) {
        return
      }
      this.$router.push('/error')
    }
  },
}
